// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"7c302e82","973":"a7f9c8ea"}[chunkId] + ".chunk.js";
};